import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CompanyWorkflow, ConnectPhasesInput, DisconnectPhaseInput, WorkflowPort } from '../domain/workflow'

const connectPhases = async (
	port: WorkflowPort,
	input: ConnectPhasesInput,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.connectPhases(input)
		notify.success('workflow.phasesConnected')
		return workflow
	} catch {
		notify.error('workflow.phaseConnectFailed')
		return null
	}
}

const disconnectPhase = async (
	port: WorkflowPort,
	input: DisconnectPhaseInput,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.disconnectPhase(input)
		notify.success('workflow.phaseDisconnected')
		return workflow
	} catch {
		notify.error('workflow.phaseDisconnectFailed')
		return null
	}
}

export { connectPhases, disconnectPhase }
